import type { StageMode, StageOption } from '@/types'

export const STAGE_MODES: StageOption<StageMode>[] = [
    { value: 'both', label: 'שתיהן' },
    { value: 'comedy', label: 'קומדיה' },
    { value: 'tragedy', label: 'טרגדיה' }
]
